import React, { useState, useEffect, useContext } from 'react'
import { AppContext } from '../App'
import { ReactComponent as IcoBack } from '../../assets/svg/ico_back_arrow.svg'

const FilterSelector = ({ closeAction }) => {
  const { filters, setFilters, lang, getTranslatedUiLabel } = useContext(AppContext)
  const [selectedCount, setSelectedCount] = useState(0)

  useEffect(() => {
    setSelectedCount(filters.filter(t => t.selected).length)
  }, [filters])

  function toggleSelect(id) {
    setFilters(filters.map(t => t.id === id ? ({...t, selected: !t.selected}) : t))
  }

  return <div className="App-filter-selector">
    <div style={{display: 'flex'}}>
      <span className="show-mobile"><IcoBack width="24" height="24" style={{padding: '8px', display: 'inline'}} onClick={closeAction} /></span>
      <h3 className="App-filter-selector-title">{getTranslatedUiLabel(16)}{selectedCount ? ` (${selectedCount})` : ""}</h3>
    </div>
    <div className="App-filter-selector-container">
      {filters.map(f => <FilterSelectorItem key={f.id} action={() => toggleSelect(f.id)} label={f[lang]} selected={f.selected} />)}
    </div>
  </div>
}

const FilterSelectorItem = ({action, label, selected}) => <div className={"App-filter-selector-item" + (selected ? " selected" : "")} onClick={action}>{label}</div>

export default FilterSelector